<template>
    <div>
      <v-btn 
        id="risk-key-button" 
        color="midnight"
        flat
        icon
        class="risk-key-button"
        variant="text"
        block
        v-if="isMobile"
        @click="visibleItem = !visibleItem"
      >            
        <v-img :src=atradiusInfoIcon class="info-icon"/>
      </v-btn>
      <div class="risk-key" v-if="visibleItem">
        <v-row v-if="isMobile">
          <v-col cols="10">
            <h5 class="mobileHeaderText">Colour indicators</h5>
          </v-col>
          <v-col cols="2">
            <v-btn 
              icon
              class="risk-key-close-button"
              @click="visibleItem = !visibleItem"
              
            >

              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-col>
        </v-row>
        <div v-for="item in riskMapColours" :key="item.risk" class="risk-key-item">
          <div class="risk-key-circle" :style="{ backgroundColor: item.color }"></div>
          <span class="risk-key-label">{{ item.risk }}</span>
        </div>
      </div>
    </div>
  </template>
  
  <script > //TODO : this isn't typescript
  import atradiusInfoIcon from '@/assets/icons/atradius-info.svg';
  
  export default {
    name: 'RiskKey',
    data() {
      return {
        atradiusInfoIcon: atradiusInfoIcon,
        isMobile: window.innerWidth <= 900,
        visibleItem: true,
        riskMapColours: [
          { risk: 'Low Risk', color: '#93BE62' },
          { risk: 'Moderate-Low Risk', color: '#BDDBB0' },
          { risk: 'Moderate Risk', color: '#FFE14F' },
          { risk: 'Moderate-High Risk', color: '#E7A723' },
          { risk: 'High Risk', color: '#EF4343' },
          { risk: 'Very High Risk', color: '#A71229' }
        ]
      };
    },
    created() {
      window.addEventListener('resize', this.handleResize);
      this.handleResize();
    },
    mounted() {
      if(this.isMobile) {
        this.visibleItem = false;
      } else {
        this.visibleItem = true;
      }

    },
    beforeUnmount() {
      window.removeEventListener('resize', this.handleResize);
    },
    methods: {
      handleResize() {
        this.isMobile = window.innerWidth <= 1025;
      }
    }
  };
  </script>
  
  <style scoped>
  .risk-key {
    display: flex;
    flex-wrap: wrap;
    background-color: rgba(251, 251, 252, 0.75);
    padding: 0px 20px;
    height: 42px;
    border-radius: 8px;
  }
  
  .risk-key-button {
    border-radius: 50%;
    display: flex;
    width: 30px;
    height: 30px;
  }
  
  .info-icon {
    margin: auto;
  }
  
  .risk-key-item {
    display: flex;
    align-items: center;
    margin-right: 20px;
  }
  
  .risk-key-item:last-child {
    margin-right: 0;
  }
  
  .risk-key-circle {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    margin-right: 10px;
  }
  
  .risk-key-label {
    font-size: 13px;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: -2%;
    font-family: 'GCO Sans', sans-serif;
  }
  
  @media (max-width: 900px) {
    .risk-key{
      position: absolute;
        bottom: 70px;
        width: 370px;
        height: 185px;
        left: 50%;
        background: white;
        transform: translateX(-50%);
    }

    .risk-key-close-button{
      background:none;
      box-shadow: none;
      margin-top: 5px;
    }
    

    .risk-key-button {
      display: block;
    }
  
    .risk-key-item {
        width: 50%;
        display: flex;
        align-items: flex-start;
        padding: 0;
        margin: 0;
        font-weight: 400;
        font-family: 'GCO', sans-serif;
    
    }

    .mobileHeaderText{
      font-family: 'GCO', sans-serif;
      font-weight: 500;
      font-size: 20px;
      margin-top: 17px;
    }
  }
  </style>
  